import { useNavigate } from "react-router-dom";

import "../../home/css/newsEvents.css";
import "../css/culturePost.css";
import truncateWords from "../../../../format/truncateWords";
import { useContext } from "react";
import { Store } from "../../../../Store";

const CulturePost = ({ posts }) => {
  const navigate = useNavigate();

  const { dispatch: ctxDispatch } = useContext(Store);

  const handleNavigative = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/tuyen-dung/co-hoi-nghe-nghiep");
  };

  const saveBreadcrumb = (post, url) => {
    const { topics } = post;

    const breadcrumb = [
      {
        title: "Bài viết",
        slug: "/bai-viet",
      },
      {
        title: topics[0].title,
        slug: topics[0].slug,
      },
    ];
    ctxDispatch({
      type: "SET_BREADCRUMB",
      payload: breadcrumb,
    });
    localStorage.setItem("resentBread", JSON.stringify(breadcrumb));
    navigate(url);
  };

  return (
    <section className="culture-posts">
      <h1 className="text-center default-box-title  mb-5">
        VĂN HÓA Nông Dược Miền Nam
      </h1>
      <div className="media-talking-about-us mt-100">
        <div className="bg-layer my-md-5 my-4 px-xl-4 px-3">
          <div className="box-wrap">
            <div className="items">
              {posts.posts.length > 0 &&
                posts.posts.map((post, index) => (
                  <div key={index} className="item-wrap bg-white shadow-sm p-3">
                    <div className="text-center mb-3">
                      <div
                        className="a"
                        style={{
                          display: "block",
                          width: "100%",
                          overflow: "hidden",
                          cursor: " pointer",
                        }}
                        onClick={() =>
                          saveBreadcrumb(
                            post,
                            `/${post.topics[0].slug}/${post.slug}`
                          )
                        }
                      >
                        <img
                          data-src={post.thumbnail}
                          className=" thumbnail owl-lazy zoom-image"
                          alt={post.title}
                          loading="lazy"
                          src={post.thumbnail}
                          style={{
                            width: "100%",
                            aspectRatio: "3/2",
                            objectFit: "cover",
                            opacity: "1",
                            transition: "transform 0.3s ease",
                          }}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <h3 className="mb-3">
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            saveBreadcrumb(
                              post,
                              `/${post.topics[0].slug}/${post.slug}`
                            )
                          }
                        >
                          {truncateWords(post.title, 12)}
                        </div>
                      </h3>
                      <p>{truncateWords(post.short_description, 20)}</p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className="redirect">
        <h3>Nông Dược Miền Nam</h3>
        <p>Nông Dược Miền Nam đang chờ bạn. Gia nhập và khám phá ngay!</p>
        <button onClick={handleNavigative}>Các vị trí đang tuyển</button>
      </div>
    </section>
  );
};

export default CulturePost;
